export default function ProductHero() {
  return (
    <>
      {/* Hero Banner */}
      <section className="product-hero">
        <img
          src="/products-banner.png"
          alt="RelyOnne UK - Paper & Board Products"
          className="hero-image"
        />
      </section>

      {/* Introduction */}
      <section className="products-intro">
        <div className="intro-container">
          <span className="intro-tag">WHAT WE OFFER</span>

          <h2>Premium Paper & Board Solutions</h2>

          <p>
            At <strong>RelyOnne UK Limited</strong>, we provide a comprehensive
            range of high-quality paper and board products to meet the evolving
            needs of businesses across printing, packaging, publishing and
            industrial sectors. Our commitment to quality, reliability and
            sustainable sourcing ensures that every product delivers exceptional
            value and consistent performance.
          </p>

          <div className="intro-buttons">
            <a href="#products" className="btn-primary">
              Explore Products
            </a>

            <a href="/contact" className="btn-outline">
              Request a Quote
            </a>
          </div>
        </div>
      </section>
    </>
  );
}